module.exports = __webpack_public_path__ + "static/media/James Monroe (I) - 1820.1901c3db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/James Monroe (I) - 1820.jpg
// module id = 506
// module chunks = 0